import { debounce, put } from "redux-saga/effects";

import {
  OSD_FULLY_LOADED_CHANGE,
  SLIDE_TILES_LOADED,
} from "../actions/constants";

function* tilesFullyLoaded(action: any) {
  yield put({
    type: SLIDE_TILES_LOADED,
    payload: action.payload,
  });
}

export function* slideTileSaga() {
  yield debounce(200, OSD_FULLY_LOADED_CHANGE, tilesFullyLoaded);
}
